import { render } from "./CommandSelector.vue?vue&type=template&id=83e1c756&scoped=true"
import script from "./CommandSelector.vue?vue&type=script&lang=js"
export * from "./CommandSelector.vue?vue&type=script&lang=js"

import "./CommandSelector.vue?vue&type=style&index=0&id=83e1c756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83e1c756"]])

export default __exports__